import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('back-link-component',{attrs:{"to":{ name: 'BillingBilling' },"label":_vm.$tt('customBillingMenu')}}),_c('h2',[_vm._v(_vm._s(_vm.$tt('customBillingMethod')))]),_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"md":"6","cols":"12"}},[_c('credit-card-list-component')],1),_c(VCol,{attrs:{"md":"6","cols":"12"}},[_c('add-credit-card-component')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }